import {useMemo} from "react";
import {useAccessToken} from "../auth";
import {useClientId} from "../ClientIdProvider";
import {useTenantId} from "../tenant";
import {createApiClientWithBaseConfig} from "./client";

export function useKpiApi() {
	const accessToken = useAccessToken();
	const tenantId = useTenantId();
	const clientId = useClientId();
	return useMemo(() => createKpiApi(tenantId, clientId, accessToken), [tenantId, accessToken]);
}

function createKpiApi(tenantId: string, clientId: string | undefined, accessToken: string | undefined) {
	const {api, withConfig} = createApiClientWithBaseConfig(clientId, accessToken);
	return {
		getTotalBookings: () =>
			api.get(
				"/api/tenants/{tenantId}/kpis/total-bookings",
				withConfig({
					path: {tenantId},
				}),
			),
		getTotalCompartments: () =>
			api.get(
				"/api/tenants/{tenantId}/kpis/total-compartments",
				withConfig({
					path: {tenantId},
				}),
			),
		getTotalUsers: () =>
			api.get(
				"/api/tenants/{tenantId}/kpis/total-users",
				withConfig({
					path: {tenantId},
				}),
			),
		getAverageBookingDuration: () =>
			api.get(
				"/api/tenants/{tenantId}/kpis/average-booking-duration",
				withConfig({
					path: {tenantId},
				}),
			),
		getUtilization: () =>
			api.get(
				"/api/tenants/{tenantId}/kpis/utilization",
				withConfig({
					path: {tenantId},
				}),
			),
	};
}
